<script lang="ts">
	// components
	import Button from '$components/utilities/Button.svelte';

	// types
	import type { EmptyState } from '$types/EmptyState';

	// * required props *
	export let emptyState: EmptyState;

	const { description, icon, size = 'lg', title } = emptyState;
</script>

<div
	class={`mx-auto flex w-64 flex-col items-center justify-center text-center ${
		$$props.class ? $$props.class : ''
	}`}
>
	<svelte:component this={icon} class={`${size === 'sm' ? 'h-10' : 'h-14'} text-zinc-500`} />
	<h5 class={`${size === 'sm' ? 'text-lg' : 'text-xl'} handwritten mt-3`}>{title}</h5>
	<p class={`${size === 'sm' ? 'mt-0.5 text-sm' : 'mt-1.5 text-base'} text-zinc-300`}>
		{description}
	</p>
	{#if emptyState?.button}
		<Button
			class="mt-5"
			href={emptyState.button?.href ? emptyState.button.href : undefined}
			icon={emptyState.button.icon}
			isFullWidth
			kind={emptyState.button?.kind ?? 'secondary'}
			onClick={emptyState.button.onClick}
			title={emptyState.button?.title ?? ''}
		/>
	{/if}
</div>
